export enum WidgetCssClassNameEnum {
  TOP = 'scroll-top',
  RELATIVE = 'relative',
  UP = 'scroll-up',
  DOWN = 'scroll-down',
  NORMAL = 'normal',
}
